import { all, fork } from 'redux-saga/effects';
// import activeOrdersSaga from './activeOrders.saga';
import authSaga from './auth.saga';
import dashboardSaga from './dashboard.saga';
import hotelSaga from './hotel.saga';
import inventorySaga from './inventory.saga';
import inviteSaga from './invite.saga';
import menuSaga from './menu.saga';
import orderPlacementSaga from './orderPlacement.saga';
import orderSaga from './orders.saga';
import paymentActivationSaga from './paymentActivation.saga';
import managerSaga from './staff.saga';
import tablesSaga from './tables.saga';

export default function* () {
    yield all([
        fork(authSaga),
        fork(managerSaga),
        fork(hotelSaga),
        fork(inviteSaga),
        fork(menuSaga),
        fork(tablesSaga),
        fork(orderPlacementSaga),
        fork(paymentActivationSaga),
        fork(orderSaga),
        fork(dashboardSaga),
        // fork(activeOrdersSaga),
        fork(inventorySaga)
    ]);
}
